import type { GradePublic } from '@repo/types/grades';

import { cn } from '@repo/lib/cn';
import { format } from 'date-fns';
import { ArrowUpRight } from 'lucide-react';

import GradeDetailsPopup from '@/components/features/grades/GradeDetailsPopup';
import GradeValuePill from '@/components/features/grades/GradeValuePill';
import { Badge } from '@/components/ui/badge';

interface GradeCardProps {
  grade: GradePublic;
  className?: string;
}

export default function GradeCard({ grade, className }: GradeCardProps) {
  return (
    <div className={cn('flex items-center gap-3 py-2', className)}>
      <GradeValuePill grade={grade} />
      <div className={'flex min-w-0 flex-col'}>
        <span className={'text-foreground truncate text-sm font-medium'}>{grade.name}</span>
        <span className={'text-muted-foreground text-xs'}>{format(new Date(grade.createdAt), 'd MMM yyyy')}</span>
      </div>
      <GradeDetailsPopup grade={grade} side={'left'}>
        <Badge asChild variant={'muted'} size={'sm'} className={'ml-auto'}>
          <button type={'button'}>
            Więcej
            <ArrowUpRight />
          </button>
        </Badge>
      </GradeDetailsPopup>
    </div>
  );
}
